import * as yup from "yup";

export function createSchema() {
  return yup.object().shape({
    name: yup.lazy(() => {
      return yup.string().nullable().required("Please enter policy set name.");
    }),
  });
}
